document.addEventListener("DOMContentLoaded", () => {
  // basic spam protection against dumb crawlers
  document.querySelectorAll("a[data-mail]").forEach((el) => {
    const reconstructed = el.dataset.mail.replaceAll("[ätt]", "@");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          unmangle();
        }
      });
    });

    observer.observe(el);

    function unmangle() {
      el.innerHTML = reconstructed;
      el.setAttribute("href", `mailto:${reconstructed}`);

      observer.disconnect();
    }
  });
});
